import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-support-buttons',
  templateUrl: './support-buttons.component.html',
  styleUrls: ['./support-buttons.component.scss'],
  standalone: true,
  imports: [
    RouterModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportButtonsComponent {
  cssClass: 'fadeIn' | 'fadeOut' = 'fadeOut';

  toggleFab() {
    this.cssClass = this.cssClass === 'fadeIn' ? 'fadeOut' : 'fadeIn';
  }
}
